export class InformacionSerie {
    id!:number;
    indicador!:string;
    periodicidad!:string;
    fecha_proxima_publicacion!:string;
    fecha_ultima_publicacion_disponible!:string;
    valor_dato_publicado!:string;
    fecha_ultimo_dato_publicado!:string;
    categoria!:string;
    unidad!:string;
    enlace_pagina_externa!:string;
    tipo_tasa!:string;
    clasificacion!:string;

    nombre!: string;
    subcategoria!: string;
    idPeriodicidad!: string;
    descripcionPeriodicidad!: string;
    categoriaNivel1!: string;
    categoriaNivel2!: string;
    categoriaNivel3!: string;
    ajusteEstacional!: string;
    base!: string;
    descripcion!: string;
    fichaTecnica!: any;
    fuente!: string;
    fechaInicial!: string;
    fechaFinal!: string;
    notas!: string;
    fechaUltimoCargue!: string;
    geografia!: string;
    precio!: string;
    periodoReferencia!: string;
    valor!: number;

    menu!: string;
    submenu!: string;

}
